const allRouter = {
  //异常消费
  101: {
    path: '/dashboard',
    path_district: '/dashboard',
    isActive: false,
  },
  102: {
    path: '/singleCard',
    isActive: false,
  },
  //办卡数据
  202: {
    path: '/cardMap',
    path_district: '/cardProvince',
    isActive: false,
  },
  //一车多卡
  203: {
    path: '/oneCarmulticard',
    isActive: true,
  },
  //消费数据
  302: {
    path: '/consumpRegion',
    path_district: '/consumpProvince',
    isActive: false,
  },
  303: {
    path: '/conCard',
    path_district: '/conCardProvince',
    isActive: false,
  },
  //货运平台
  10: {
    path: '/carVehicle',
    isActive: false,
  },
  11: {
    path: '/carTrain',
    isActive: false,
  },
  12: {
    path: '/carStop',
    isActive: false,
  },
  13: {
    path: '/carPath',
    isActive: false,
  },
  14: {
    path: '/carOperate',
    isActive: false,
  },
  16: {
    path: '/carGas',
    isActive: false,
  },

  402: {
    path: '/carTonnage',
    isActive: false,
  },
  403: {
    path: '/carOperateTon',
    isActive: false,
  },
  404: {
    path: '/carMilenge',
    isActive: false,
  },
  405: {
    path: '/carTime',
    isActive: false,
  },
  406: {
    path: '/carProvinceMileage',
    isActive: false,
  },
  407: {
    path: '/carLogis',
    isActive: false,
  },
  633: {
    path: '/carLogisT',
    isActive: false,
  },
  408: {
    path: '/carGasStation',
    isActive: false,
  },
  409: {
    path: '/carTrains',
    path_district: '/carTrainsDetail',
    isActive: false,
  },
  410: {
    path: '/carPriviceBrand',
    isActive: false,
  },
  411: {
    path: '/carStopBrand',
    isActive: false,
  },
  632: {
    path: '/carStopBrandT',
    isActive: false,
  },
  412: {
    path: '/carUnpetrifiedDetail',
    isActive: false,
  },
  413: {
    path: '/carUnpetrifiedCom',
    isActive: false,
  },
  414: {
    path: '/highSpeedRoad',
    isActive: false,
  },
  624:{
    path: '/weeklyCarOperate',
    isActive: false,
  },
  421: {
    path: '/highSpeedRoad',
    isActive: false,
  },
  630: {
    path: '/highSpeedRoadT',
    isActive: false,
  },
  631: {
    path: '/nationalRoadT',
    isActive: false,
  },
  422: {
    path: '/nationalRoad',
    isActive: false,
  },
  423: {
    path: '/provinceRoad',
    isActive: false,
  },
  620: {
    path: '/carLogisWeek',
    isActive: false,
  },
  621: {
    path: '/carStopBrandWeek',
    isActive: false,
  },
  622: {
    path: '/highSpeedRoadWeek',
    isActive: false,
  },
  623: {
    path: '/nationalRoadWeek',
    isActive: false,
  },
  626: {
    path: '/carLogisWeekT',
    isActive: false,
  },
  627: {
    path: '/carStopBrandWeekT',
    isActive: false,
  },
  628: {
    path: '/highSpeedRoadWeekT',
    isActive: false,
  },
  629: {
    path: '/nationalRoadWeekT',
    isActive: false,
  },
  424: {
    path: '/carMileViaProvince',
    isActive: false,
    path_district: '/carMileViaProvinceDetail',
  },
  415: {
    path: '/roadOperation/allRoad',
    isActive: false,
  },
  502: {
    path: '/comprehensiveData',
    isActive: false,
  },
  614: {
    path: '/loginLog',
    isActive: false,
  },
  615: {
    path: '/claimDetails',
    isActive: false,
  },
  616: {
    path: '/developData',
    isActive: false,
  },
  704: {
    path: '/developSumData',
    isActive: false,
  },
  705: {
    path: '/carStopBrand',
    isActive: false,
  },
  706: {
    path: '/carLogis',
    isActive: false,
  },
  707: {
    path: '/weeklyCarOperate',
    isActive: false,
  },
  617: {
    path: '/noLoginDetailsCustomer',
    isActive: false,
  },
  618: {
    path: '/claimDetailsCustomer',
    isActive: false,
  },
  619: {
    path: '/developDataCustomer',
    isActive: false,
  },
  610: {
    path: '/carUnpetrifiedComAll',
    isActive: false,
  },
  611: {
    path: '/carUnpetrifiedComGoal',
    isActive: false,
  },
  612: {
    path: '/cardListUser',
    isActive: false,
  },
  418: {
    path: '/weeklyCarOperate',
    isActive: false,
  },
  419: {
    path: '/weeklyBrandGas',
    isActive: false,
  },
}

export default allRouter
